module.exports = __webpack_public_path__ + "img/sonolenta.c8904034.png";